import { Box, SkeletonGroup, SkeletonRectangle } from '@wix/design-system';
import { ECLIPSE_BG } from '@wix/package-picker-shared-eclipse';
import React from 'react';
import { AllPlansIncludeSkeleton } from '../AllPlansIncludedFeaturesBanner/AllPlansIncludeSkeleton';
import { Background } from '../Background';
import { AiPlanTitleLoading } from '../PageTitle/AiPlanTitleLoading';
import { ProductCardsSkeleton } from '../ProductCards/ProductCardsSkeleton/ProductCardsSkeleton';
import s from './PlansSectionSkeleton.scss';

export interface PlansSectionSkeletonProps {
  /** Number of feature items in the all-plans-included banner skeleton. Defaults to 4. */
  allPlansIncludeItems?: number;
  /** Number of product cards in the skeleton. Defaults to 4. */
  numCards?: number;
  dataHook?: string;
  /**
   * When true (eclipseAiPlanCopy experiment on), replaces the generic
   * SkeletonRectangle title bar with the animated AiPlanTitleLoading text and
   * suppresses the banner shimmer so the two animations don't compete.
   * Defaults to false — the original skeleton bar is shown.
   */
  showAiTitle?: boolean;
}

export const PlansSectionSkeleton = ({
  allPlansIncludeItems = 4,
  numCards = 4,
  showAiTitle = false,
}: PlansSectionSkeletonProps) => {
  if (showAiTitle) {
    return (
      <Background backgroundColor={ECLIPSE_BG}>
        <Box align="center" width="100%" textAlign="center" marginBottom="29px">
          <AiPlanTitleLoading />
        </Box>
        <SkeletonGroup>
          <Box
            width="100%"
            marginTop="SP3"
            align="center"
            className={s.noShimmer}
          >
            <AllPlansIncludeSkeleton numItems={allPlansIncludeItems} />
          </Box>
          <Box marginTop="SP7" marginLeft="SP3" marginRight="SP3">
            <ProductCardsSkeleton numCards={numCards} />
          </Box>
        </SkeletonGroup>
      </Background>
    );
  }

  return (
    <Background backgroundColor={ECLIPSE_BG}>
      <SkeletonGroup>
        <Box align="center" width="100%" textAlign="center" marginBottom="29px">
          <SkeletonRectangle height="30px" width="492px" />
        </Box>
        <Box width="100%" marginTop="SP3" align="center">
          <AllPlansIncludeSkeleton numItems={allPlansIncludeItems} />
        </Box>
        <Box marginTop="SP7" marginLeft="SP3" marginRight="SP3">
          <ProductCardsSkeleton numCards={numCards} />
        </Box>
      </SkeletonGroup>
    </Background>
  );
};
